import { ReviewEntryProcessingStatus } from '../enums/reviewEntryProcessingStatus'

export const isReviewEntryProcessingStatus = (status: string | undefined): boolean => {
  const normalizedStatus = status?.toLowerCase() ?? ''

  return (
    normalizedStatus === ReviewEntryProcessingStatus.Processing ||
    normalizedStatus === ReviewEntryProcessingStatus.Received
  )
}
